import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-113" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-114" data-mp="1dxji3e196zd1">
        <SectionHeading id="modules-title" data-id="element-115" data-mp="1dunhtj1xnylf">The {totalVolumes} <span className="text-primary" data-id="element-116" data-mp="2bj7ew01mfjp3">Professional Volumes</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-117" data-mp="26kw3vlzlb35a">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-primary/30 bg-surface p-6 shadow-glow" data-id="element-118" data-mp="21nvxf9ytvydn" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-119" data-mp="1ntk1a9xga7n8">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary text-background shadow-[0_0_14px_rgba(0,200,248,0.5)]" data-id="element-120" data-mp="18xuck40vrget">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-121" data-mp="1dxyrhpm5432x" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-cta" data-id="element-122" data-mp="102wfckqp9hho">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-lg font-bold leading-tight text-foreground" data-id="element-123" data-mp="q734d5smpw20">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-124" data-mp="v4uxu48x9q8b">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}